/**
 * Football 101's slot in the match HUD. The v2 tutorial (coach panel, world bubble, field guides, spotlights, title
 * slate, lesson-clear cards) lives in ui/tutorial/TutorialOverlay.tsx; this file keeps the HUD's mount point.
 */
import { TutorialOverlay } from '../tutorial/TutorialOverlay';
import type { MatchSetup } from '@hf/client-core/ui-model/types';

export function TutorialCard({ setup }: { setup: MatchSetup | null }) {
  return <TutorialOverlay setup={setup} />;
}
